// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__IVegx","app":"Layout_app__l9nmR","right":"Layout_right__0SiiN","center":"Layout_center__KzdWR"};